import styled from 'styled-components';

export const Styled = styled.div`

    ${p => p.theme.breakpoints.up('md')} {
        form {
            margin: auto;
            padding: 0 40px 0 40px;
            max-width: 720px;
        }
    }
    @media only screen and (min-width: 1920px) {
        form {
            margin: auto;
            padding: 0 120px 0 120px;
        }
    }

    padding: 20px 30px 30px 30px;

    .heading {
        width: 100%;
        text-align: center;
    }

    ${(p) => p.theme.breakpoints.down('xs')} {
        padding:16px;
    }

    && hr {
        border-top: 1px solid rgb(175 175 175 / 60%);;
    }

    .field-description {
        a, a:hover {
            color: #fff;
        }
        p {
            margin: 0;
        }
    }

    .custom-file-upload, .fileUploadOptions {
        button {
            width:200px;
            margin-bottom: 16px;
            .underline.container {
                text-align: center;
                width: 100%;
                display: block;
                padding: 0;
            }
        }
    }

    textarea {
        margin-top: 16px;
        padding-top: 16px;
        padding-bottom: 16px;
    }

    label {
        display: inline-block;
    }

    .questions,
    .education-section, .education-form-fields, .demographic-questions {
        justify-content: space-between;
        a {
            color: #fff;
            &:hover {
                color: #fff;
            }
            display: block;
            text-align: left;
            width: fit-content;

        }
        a:focus {
            padding: 5px;
        }
    }

    .questions .dropdown-autocomplete {
        width: 100%;
    }

    .questions,
    .education-section {

        input,
        textarea,
        select {
            padding-left: 16px;
            padding-right: 16px;
            font-size: 16px;
            height: 60px;
            border: none;
            margin-top: 8px;
            background-color: #202024;
            caret-color: #fff;
            color: #fff;
            &::placeholder {
                color: #757575;
            }

            width: 100%;
            ${(p) => p.theme.breakpoints.down('sm')} {
                width: 100%;
            }
        }

        .custom-file-upload {
            margin-top: 8px;
        }

        input[type=file] {
            margin-top: 5px;
        }

        select {
            /** for the dropdown indicator */
            padding-right: 35px;
            appearance: none;
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 1rem center;
            background-size: 1em;
        }

        select[multiple] option:checked {
            background-color: ${(p) => p.theme.palette.neutral.silver};
            color: white;
        }

        textarea {
            min-height: 120px;
        }

        .resume-or-cover {
            textarea {
                margin-bottom: 16px;
            }
            textarea.validate-error {
                margin-bottom: initial;

            }
        }

        .resumeOrCoverLetter-text {
            .validate-msg {
                margin-bottom: 16px;
            }
        }



        ${(p) => p.theme.breakpoints.up('md')} {
            .field-group {
                width: 100%;
            }
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            .custom-select {
                width: 100%;
            }
            .field-group {
                width: 100%;
                margin: 0;
            }
        }
    }

    .education-section {
        input,
        textarea,
        select {
            width: 100%;
            ${(p) => p.theme.breakpoints.down('sm')} {
                width: 100%;
            }
        }

        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .education-form-fields {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        ${(p) => p.theme.breakpoints.down('sm')} {
            .field-group {
                width: 100%;
                margin: 0;
                margin-bottom: 15px;
            }
        }

    }

    input::placeholder, textarea::placeholder {
        color: ${(p) => p.theme.palette.neutral.steel};
        opacity: 0.8;
    }
    .fileUploadOptions {
        margin-bottom: 16px;
        display: flex;

        .underline.container {
            width: min-content;
        }

        ${(p) => p.theme.breakpoints.down('xs')} {
            flex-wrap: wrap;
            button {
                margin-bottom: 16px;
                width: 200px;
            }
        }

        .resumeOrCoverLetter-manuallyEnter {
            color: #fff;
        }
    }
    .resumeOrCoverLetter-file.hidden,
    .resumeOrCoverLetter-text.hidden {
        display: none;
    }

    select[multiple] {
        height: 90px;
    }

    input[type='file'] {
        background: unset;
        padding-left: 0px;
    }

    input[type='radio'] {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        min-width: 24px;
        min-height: 24px;
    }

    .radio-field {
        margin-bottom: 16px;
        display: flex;
        label {
            display: flex;
            align-self: center;
            width: 100%;
        }
    }

    /* Validation Errors */
    input.validate-error,
    select.validate-error,
    textarea.validate-error {
        border: 1px solid red;
    }
    label.validate-error {
        color: red;
        font-size: 16px;
    }

    .validate-msg {
        color: red;
        font-size: 14px;
    }
    .validate-submit-msg {
        color: red;

    }
    .submit-msg,
    .validate-submit-msg {
        font-size: 18px;
        text-align: center;
    }


    .demographic-questions {
        font-size: 16px;

        p {
            margin: auto;
        }
        .field-description {
            font-size: 14px;
        }
    }

    @media only screen and (min-width: 960px) and (max-width: 1416px) {
        .field-group {
            grid-template-columns: 100%;
            &.dropdown {
                grid-template-columns: 100%;
            }
        }
    }

    .field-group {
        display: grid;
        justify-content: flex-start;
        grid-template-columns: 100%;
        grid-auto-rows: min-content;
        width: 100%;

        ${(p) => p.theme.breakpoints.down('xs')} {
            width: 100%;
        }


        label {
            padding-right: 10px;
            font-size: 18px;
        }

        &.spacer-div {
            width:500px;
        }
    }

    .demographic-questions-list {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;

        .field-group {
            width: 100%;
            display: FLEX;
            justify-content: space-between;
            label {
                max-width: 100%;
                cursor: pointer;
            }
        }
    }

    @media (max-width: 1416px) {
        .field-group.dropdown select {
            width: 100%;
            ${(p) => p.theme.breakpoints.down('xs')} {
                width: 100%;
            }
        }
    }


    && .applicationFormButtons {
        text-align: center;
        .ue-link-wrap-span {
            margin-right: 20px;
        }

        button {
            margin-bottom: 10px;

            .underline.container {
                width: auto;
            }

            ${(p) => p.theme.breakpoints.down('xs')} {

                    width: 100%;
            }
        }

    }



`;
